import React, { FC, useEffect } from "react";
import {
  Box,
  Divider,
  IconButton,
  Link,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { GTAScreenType, SCREEN_TYPE } from "../../../utils/constants";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import TriggerGTAEvent from "../../../utils/GTA";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

interface Props {
  handleBackBtnClick: Function;
  pathname?: string;
}

const Utilities: FC<Props> = ({ handleBackBtnClick, pathname }) => {
  const { t } = useAppTranslation("common");
  const profileHamburgerMenuData = useAppSelector(
    (state) => state.GeneralAppElementsSlice.quickActionMenu,
  )?.[111];

  const utilitiesMenuList = profileHamburgerMenuData?.find(
    (i) => i.pathName === "utilities",
  )?.menuDetails;

  const handleCleverTapCTAClick = (item: string, itemUrl: string) => {
    triggerCleverTapEvent("serv_utilities_option_click", {
      ScreenName: "Servicing Utilities Option Selection Screen",
      ScreenType: SCREEN_TYPE.generalAppType,
      isPrevPageNameRequired: true,
      ctaText: item,
    });
    TriggerGTAEvent("serv_utilities_option_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_utilities_option_selection_screen",
      CTA_text: item,
    });
    window.location.href = itemUrl;
  };

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaUtilitiesOptSelection.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  }, []);

  return (
    <CommonMenuListPage
      title={t("hamburgerMenu.menuItems.utilities")}
      handleBackBtnClick={handleBackBtnClick}
      pathname={pathname}
    >
      <Box>
        {utilitiesMenuList
          ?.filter((item) => item.menuId)
          .map((item, index) => (
            <React.Fragment key={item.menuDisplayName}>
              <Link
                underline="none"
                color="black"
                // href={item.menuUrl ?? ""}
                onClick={() =>
                  handleCleverTapCTAClick(
                    item.menuDisplayName,
                    item.pathName ?? "",
                  )
                }
              >
                <ListItem
                  key={item.menuId}
                  secondaryAction={
                    <IconButton
                      sx={{ marginRight: 0 }}
                      edge="end"
                      aria-label="delete"
                    >
                      <KeyboardArrowRightIcon />
                    </IconButton>
                  }
                  sx={{
                    marginY: ".625rem",
                    paddingLeft: "1.5rem",
                  }}
                >
                  <ListItemAvatar>
                    <img
                      style={{
                        height: "2rem",
                      }}
                      src={item.menuIcon}
                      alt={""}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="h5" marginBottom={"0.3125rem"}>
                        {item.jsonKey ? t(item.jsonKey) : item.menuDisplayName}
                      </Typography>
                    }
                  />
                </ListItem>
              </Link>
              <Divider />
            </React.Fragment>
          ))}
      </Box>
    </CommonMenuListPage>
  );
};

export default Utilities;
